import React from "react";
import GymNavigation from "../GymNavigation";
import Box from "components/UI/Box";
import Button from "components/UI/Button";
import UserModal from "../../Modals/UserModal";
import "./style.css";
import moment from "moment";

const tableBody = (data, setSelectedUserIndex) => {
  if (data) {
    if (data.length > 0) {
      return data.map((currentItem, index, arr) => {
        const style = {
          userDataText: {
            color: "#3f4545",
            fontSize: "16px"
          },
          viewButton: {
            fontSize: "14px",
            height: "30px",
            width: "80px",
            color: "#414141"
          }
        };
        return (
          <div key={index}>
            <hr
              style={{ borderTop: "1px solid #b5b5b6", borderRadius: "0.5px" }}
            />
            <div className="div_ActiveUsers_userData">
              <div>
                <p style={style.userDataText}>{currentItem.name}</p>
              </div>
              <div>
                <p style={style.userDataText}>
                  {moment(currentItem.checkin_time).format("LT")}
                </p>
              </div>
              <div>
                <p style={style.userDataText}>
                  {`${moment().diff(
                    moment(currentItem.checkin_time),
                    "minutes"
                  )} mins`}
                </p>
              </div>
              <div>
                <Button
                  type="holo"
                  holo
                  style={style.viewButton}
                  onClick={() => {
                    setSelectedUserIndex(index);
                  }}
                >
                  View
                </Button>
              </div>
            </div>
          </div>
        );
      });
    } else return <p>No Active Users</p>;
  }
};

class ActiveUsers extends React.Component {
  state = {
    selectedUserIndex: 0,
    userModal: false
  };
  setSelectedUserIndex = newIndex => {
    this.setState({ selectedUserIndex: newIndex, userModal: true });
  };
  closeModal = () => {
    this.setState({ userModal: false });
  };
  render() {
    const { users } = this.props;

    return (
      <React.Fragment>
        <GymNavigation />
        {this.state.userModal && (
          <UserModal
            user={users[this.state.selectedUserIndex]}
            close={this.closeModal}
          />
        )}
        <div style={style.wrapper}>
          <Box outline style={style.box}>
            <div className="div_ActiveUsers_userData">
              <div>
                <p style={style.titleText}>Name</p>
              </div>
              <div>
                <p style={style.titleText}>Check In</p>
              </div>
              <div>
                <p style={style.titleText}>Duration</p>
              </div>
              <div />
            </div>
            {tableBody(users, this.setSelectedUserIndex)}
          </Box>
        </div>
      </React.Fragment>
    );
  }
}

export default ActiveUsers;

const style = {
  wrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginTop: "10px"
  },
  box: {
    width: "900px"
  },
  titleText: {
    fontSize: "25px",
    color: "#00b4d2  "
  }
};
